/**
 * Angular imports.
 */
import { Component, Input, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { FunCollectionService } from '../common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Constant imports.
 */
import { ACTION_ON, ACTION_TYPE, CONTENT_VISIBILITY, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../constants/app.constants';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Product Masking Card Component
 */
@Component({
  selector: 'app-product-masking-card',
  templateUrl: './product-masking-card.component.html',
  styleUrls: ['./product-masking-card.component.scss']
})
export class ProductMaskingCardComponent implements OnDestroy {
  @Input() content_visibility;

  public isShownWebModal = false;
  public displaySection = '';
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Content visiblity.
   */
  public contentVisibility = CONTENT_VISIBILITY;
  /**
   * Masking card on community content.
   */
  @Input() communityVisible?;

  /**
   * Necessary instances.
   */
  constructor(
    private jwtSer: JwtDecodeService,
    private postApiSer: PostApiService,
    public fcs: FunCollectionService,
    private dss: DataStorageService,
    private masterSer: MasterserviceService,
    private analyticSdk: Analytics,
    public mls: NewLanguageService) {
  }


  /**
   * show Web Modal
   */
  showWebModal(): void {
    sessionStorage.removeItem('resub');
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.VERIFY_NOW, null);
    this.assignAssociation();
  }
  /**
   * assign Association
   */
  assignAssociation(): void {
    this.dss.selected_suggAssList = [];
    this.subscriptions.add(this.postApiSer.assignAssociation('association', '[]', '', 0).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterSer.showWebModal.next(this.displayObj);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }


  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
